export class ButtonZoneTelemetryConstants {
  public static readonly AltSingleMouseClickType = 'AltClick';
  public static readonly SingleMouseClickType = 'SingleClick';
  public static readonly EnterSpaceKeyClickType = 'EnterSpaceKey';
  public static readonly DoubleMouseClickType = 'DoubleClick';
}
